module.exports = __webpack_public_path__ + "img/retention-framework.07cff429.svg";